import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78644232"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mod_wrap" }
const _hoisted_2 = { class: "mod_c_title" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "item_line" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item_line_name" }, "观看人数显示单位：", -1))
const _hoisted_6 = { class: "item_line" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item_line_name" }, "控台礼物消息：", -1))
const _hoisted_8 = {
  key: 0,
  class: "item_line"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item_line_name" }, "视频清晰度设置：", -1))
const _hoisted_10 = { class: "save" }

import Crumb from '@/components/Crumb.vue';
import { useRoute } from 'vue-router';
import { message, Radio } from 'ant-design-vue';
import { computed, ref } from 'vue';
import http from '@/api/population';
import { useDebounce } from '@/hooks/useDebounce'; //防抖
import { useHomeStore } from '@/pinia/home';


export default /*#__PURE__*/_defineComponent({
  __name: 'Population',
  setup(__props) {

const aRadioGroup = Radio.Group;
const aRadio = Radio;
const route = useRoute();

const numStatus = ref(0);
const giftStatus = ref(0);
const videoDpi = ref(0);

const getInfo = () => {
  http
    .get_unit_status()
    .then((res) => {
      numStatus.value = res.data.data.unit_status;
      giftStatus.value = res.data.data.gift_display_status;
      videoDpi.value = res.data.data.set_resolution;
    })
    .catch((err) => console.error(err.data.error));
};
getInfo();

const setInfo = useDebounce(() => {
  http
    .set_unit_status({ unit_status: numStatus.value, gift_display_status: giftStatus.value, set_resolution: videoDpi.value })
    .then((res) => message.success(res.data.message))
    .catch((err) => message.error(err.data.error));
});

const homeStore = useHomeStore();
const showLegibility = computed(() => homeStore.funcData?.videoLegibility);

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Crumb),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(route).meta.title), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_unref(aRadioGroup), {
            name: "radioGroup",
            value: numStatus.value,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((numStatus).value = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(aRadio), { value: 0 }, {
                default: _withCtx(() => [
                  _createTextVNode("人")
                ]),
                _: 1
              }),
              _createVNode(_unref(aRadio), { value: 1 }, {
                default: _withCtx(() => [
                  _createTextVNode("万人")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_unref(aRadioGroup), {
            name: "radioGroup",
            value: giftStatus.value,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((giftStatus).value = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(aRadio), { value: 1 }, {
                default: _withCtx(() => [
                  _createTextVNode("显示")
                ]),
                _: 1
              }),
              _createVNode(_unref(aRadio), { value: 0 }, {
                default: _withCtx(() => [
                  _createTextVNode("不显示")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"])
        ]),
        (_unref(showLegibility))
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _hoisted_9,
              _createVNode(_unref(aRadioGroup), {
                name: "radioGroup",
                value: videoDpi.value,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((videoDpi).value = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(aRadio), { value: 0 }, {
                    default: _withCtx(() => [
                      _createTextVNode("720 分辨率")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(aRadio), { value: 1 }, {
                    default: _withCtx(() => [
                      _createTextVNode("1080 分辨率")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: _unref(setInfo)
          }, {
            default: _withCtx(() => [
              _createTextVNode("保存")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ])
  ], 64))
}
}

})